/**
 * Login Page for Admin Console
 *
 * Delegates all authentication to the Account Region (AR), the canonical
 * identity provider. The shared AuthGuard already redirects to
 * getIdentityBrowserUrl()/self-service/login/browser for unauthenticated
 * users; this page is a safety net for direct /auth/login access.
 */

import { useEffect } from "react";
import { getIdentityBrowserUrl } from "shared/lib/identity-client";

export function LoginPage() {
  useEffect(() => {
    const returnTo = new URLSearchParams(window.location.search).get("return_to") || window.location.origin + "/";
    window.location.href = `${getIdentityBrowserUrl()}/self-service/login/browser?return_to=${encodeURIComponent(returnTo)}`;
  }, []);

  return null;
}

export default LoginPage;
